import {useState} from 'react';
import {useTranslation} from 'react-i18next';

export default function Settings() {
  const defaultLNG = window.localStorage.getItem('lng') || 'en_US';
  const [lng, setLng] = useState(defaultLNG);

  const {t} = useTranslation(['settings']);

  const handleChange = e => {
    setLng(e.target.value);
  };

  const handleSave = e => {
    window.localStorage.setItem('lng', lng);
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };
  return (
    <main id="content" role="main">
      <div className="w-md-75 w-lg-50 text-center mx-md-auto space-top-2 pb-3">
        <h1 className="h3">{t('settings.title')}</h1>
        <p>{t('settings.lable1')}</p>
      </div>

      <div className="container space-bottom-2">
        <div className="w-md-75 w-lg-50 mx-md-auto">
          <div className="card mb-3">
            <div className="card-body p-4">
              <form method="post" action="./settings" id="ctl00">
                <div className="media align-items-center">
                  <label className="media-body text-secondary mb-0" htmlFor="checkboxSwitch">
                    <h3 className="h6 font-weight-bold mb-1">{t('settings.advance_title')}</h3>
                    <span>{t('settings.advance_lable')}</span>
                  </label>
                  <label className="checkbox-switch ml-3 mb-0">
                    <input
                      type="checkbox"
                      className="checkbox-switch__input"
                      checked="checked"
                      onChange={e => {
                        console.log(e);
                      }}
                    />
                    <span className="checkbox-switch__slider"></span>
                  </label>
                </div>

                <hr />

                <div className="media align-items-center">
                  <label className="media-body text-secondary mb-0">
                    <h3 className="h6 font-weight-bold mb-1">{t('settings.language')}</h3>
                    <span>{t('settings.language_lable')}</span>
                  </label>
                  <select onChange={handleChange} defaultValue={lng} className="custom-select custom-select-xs font-size-base ml-3 pb-1">
                    <option value="en_US">English</option>
                    <option value="zh_CN">中文 (CN)</option>
                  </select>
                </div>

                <hr />

                <div className="media align-items-center d-none">
                  <label className="media-body text-secondary mb-0">
                    <h3 className="h6 font-weight-bold mb-1">
                      Currency <span className="badge badge-success ml-1">New</span>
                    </h3>
                    <span>Choose desired currency</span>
                  </label>
                  <select className="custom-select custom-select-xs font-size-base ml-3 pb-1">
                    <option value="USD">United States Dollar</option>
                  </select>
                </div>

                <hr className="d-none" />
                <div className="text-right">
                  <input type="button" onClick={handleSave} value={t('settings.btn_save')} className="btn btn-xs btn-primary" />
                </div>
              </form>
            </div>
          </div>
          <p className="font-size-1">{t('settings.cookie')}</p>
        </div>
      </div>
    </main>
  );
}
